import { api } from '../configs/axiosConfigs';

export type AuctionIdOption = {
  property_id: string;
  auction_number: string;
};

// Suggestions for the Decision Making "Custom List ID" lookup (whole list, ignores sidebar filters)
export const getAuctionIds = async(listSortId: string, query: string): Promise<AuctionIdOption[]> => {
  const response = await api.get(`list-sorts/${listSortId}/auction_ids`, { params: { query, limit: 25 } });
  return response.data;
};
